/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import "./CSS/layout.css";
import apiService from "../../services/api-service";
import ComplexStatisticsCard from "../../examples/Cards/StatisticsCards/ComplexStatisticsCard";
import BasicLayoutLanding from "../../layouts/authentication/components/BasicLayoutLanding";
import { AuthContext } from "context";

function AreaSelection() {
	const authContext = useContext(AuthContext);
	const [aree, setAree] = useState([]);
	const navigate = useNavigate();

	useEffect(() => {
		apiService
			.get("/user-area/", {}, {})
			.then((data) => setAree(data))
			.catch((error) => console.log(error));
	}, []);

	function selectArea(area) {
		localStorage.removeItem("gestioneGlobale"); // Clear gestione globale mode
		localStorage.setItem("areaSelected", area[0]);
		localStorage.setItem("areaName", area[1]);
		apiService
			.get("/user-area-auth/", `area=${area[0]}`, {})
			.then((data) => authContext.setAuth(data), navigate("/"))
			.catch((error) => console.log(error));
		apiService
			.get("/check-user-supplier/", null, {})
			.then((data) => {
				if (data?.supplier) {
					localStorage.setItem("supplier", data?.supplier);
				}
			})
			.catch((error) => console.log(error));
	}

	function selectGestioneGlobale() {
		localStorage.removeItem("areaSelected");
		localStorage.removeItem("areaName");
		localStorage.setItem("gestioneGlobale", "true");
		navigate("/");
	}

	return (
		<BasicLayoutLanding>
			<Box className="container">
				{aree.map((area) => {
					return (
						<MDBox width="100%" onClick={() => selectArea(area)} key={area[0]}>
							<ComplexStatisticsCard
								color="dark"
								icon="home"
								title="Cantiere"
								count={area[1]}
							/>
						</MDBox>
					);
				})}
			</Box>
			<Box sx={{ maxWidth: "600px", margin: "0 auto", mt: 4 }}>
				<Divider sx={{ borderColor: "rgba(255,255,255,0.3)" }} />
			</Box>
			<Box className="container" sx={{ mt: 4 }}>
				<MDBox width="100%" onClick={selectGestioneGlobale}>
					<ComplexStatisticsCard
						color="info"
						icon="admin_panel_settings"
						title="Gestione"
						count="Globale"
						percentage={{
							color: "info",
							label: "Anagrafiche, Esportazioni e Sicurezza",
						}}
					/>
				</MDBox>
			</Box>
		</BasicLayoutLanding>
	);
}

export default AreaSelection;
